import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue'
import { createLayerPlugin, createNativeBridge } from '@gsretail/gssm-ui-mobile/dlvr'
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2'

import '@/assets/scss/_index.scss'
import '@/assets/scss/gs_calendarDM.scss'

import App from './App.vue'
import router from '@/router'

import { initLogger } from './utils/logger'

const notNeedNativeBridgePath = ['/comm/AUTH-CALLBACK']

initLogger()

const head = createHead()

createNativeBridge(notNeedNativeBridgePath).then((nativeBridePlugin) => {
  const app = createApp(App)
  app.use(head)
  app.use(router)
  app.use(nativeBridePlugin)
  app.use(createLayerPlugin(), {
    router,
    isDlvr: true
  })
  const pinia = createPinia()
  const installPersistedStatePlugin = createPersistedStatePlugin({
    storage: $nvBridge.deviceStoragePinia
  })

  pinia.use((context) => {
    if (context.store.$id === 'useAPPstore') {
      nativeBridePlugin.setStore(context.store)
    }
    context.store.router = markRaw(router)
    installPersistedStatePlugin(context)
  })

  // pinia.use(
  //   createPersistedState({
  //     key: (id) => `GSSM_MOBILE_${id}`
  //   })
  // )

  app.use(pinia)

  app.mount('#app')
})
